import { Node, mergeAttributes } from "@tiptap/core";
import { buildDateNodeAttrs, formatDateLabel } from "./dateNodeUtils";

export { buildDateNodeAttrs, formatDateLabel } from "./dateNodeUtils";

export const DateNode = Node.create({
  name: "date",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      isoDate: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-iso-date"),
        renderHTML: (attributes) => {
          if (!attributes.isoDate) {
            return {};
          }

          return {
            "data-iso-date": attributes.isoDate,
          };
        },
      },
      label: {
        default: null,
        parseHTML: (element) => element.textContent?.trim() || null,
      },
    };
  },

  parseHTML() {
    return [{ tag: "span[data-date-node]" }];
  },

  renderHTML({ node, HTMLAttributes }) {
    const label =
      node.attrs.label || formatDateLabel(node.attrs.isoDate) || "Date";

    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-date-node": "",
        class: "tiptap-date",
      }),
      label,
    ];
  },

  addCommands() {
    return {
      insertDate:
        (attrs) =>
        ({ chain }) =>
          chain()
            .insertContent({
              type: this.name,
              attrs: buildDateNodeAttrs(attrs.isoDate),
            })
            .run(),
    };
  },
});
